import { getLuminance } from 'polished';
import { fg } from '@atlaskit/platform-feature-flags';
import { generateThemeBranding } from '@atlassian/csm-colour-theme-generator';
import { DEFAULT_BRANDING_COLOR, HUB_PRIMARY_COLOR_CSS_VAR, HUB_PRIMARY_LINK_COLOR_CSS_VAR, HUB_PRIMARY_TEXT_COLOR_CSS_VAR } from '../../constants';
var readableTextColor = function readableTextColor(color) {
  return getLuminance(color) > 0.5 ? "var(--ds-text, #292A2E)" : "var(--ds-text-inverse, #FFFFFF)";
};
export var setHubBrandingStyle = function setHubBrandingStyle(_ref) {
  var primaryColor = _ref.primaryColor,
    targetElement = _ref.targetElement;
  var primaryColorToUse = primaryColor || DEFAULT_BRANDING_COLOR;
  var primaryTextColor = readableTextColor(primaryColorToUse);
  var finalTargetElement = targetElement || document.documentElement;
  finalTargetElement.style.setProperty(HUB_PRIMARY_COLOR_CSS_VAR, primaryColorToUse);
  finalTargetElement.style.setProperty(HUB_PRIMARY_TEXT_COLOR_CSS_VAR, primaryTextColor);
  if (fg('csm_help_center_branding_updates')) {
    var themeColours = generateThemeBranding(primaryColorToUse);
    finalTargetElement.style.setProperty(HUB_PRIMARY_LINK_COLOR_CSS_VAR, themeColours.color900);
  }
  return function () {
    finalTargetElement.style.removeProperty(HUB_PRIMARY_COLOR_CSS_VAR);
    finalTargetElement.style.removeProperty(HUB_PRIMARY_TEXT_COLOR_CSS_VAR);
    if (fg('csm_help_center_branding_updates')) {
      finalTargetElement.style.removeProperty(HUB_PRIMARY_LINK_COLOR_CSS_VAR);
    }
  };
};